import pageNotFound from "./icons/404.svg";
import actionEdit from "./icons/action-edit.svg";
import actionRelock from "./icons/action-relock.svg";
import actionRight from "./icons/action-right.svg";
import actionTrash from "./icons/action-trash.svg";
import addLabelQuestion from "./icons/add-label-question.svg";
import addIcon from "./icons/AddIcon.svg";
import advertise from "./icons/ads_icon.png";
import alignJustifyIcon from "./icons/align-justify.svg";
import alignLeftIcon from "./icons/align-left.svg";
import alignRightIcon from "./icons/align-right.svg";
import applicant from "./icons/applicant.svg";
import backIcon from "./icons/back.svg";
import backArrow from "./icons/back_arrow.svg";
import blacKTick from "./icons/black-tick.svg";
import camera from "./icons/camera.svg";
import employ from "./icons/clarity_employee-solid.svg";
import bell from "./icons/clarity_notification-solid.svg";
import subtag from "./icons/clarity_tags-solid.svg";
import closeGray from "./icons/close-gray.svg";
import cross from "./icons/cross.svg";
import dashboardDark from "./icons/dashboard-dark.svg";
import dashboardDevIco from "./icons/dashboard-developers.svg";
import dashboardLight from "./icons/dashboard-light.svg";
import dashboardMembersIco from "./icons/dashboard-members.svg";
import dashboardProjIco from "./icons/dashboard-project-site.svg";
import dashboardSubMembersIco from "./icons/dashboard-sub-members.svg";
import dashboard from "./icons/dashboard_icon.png";
import defaultProfile from "./icons/defaultprofile.svg";
// import deleteIcon from "./icons/delete.svg";
import callContact from "./icons/call-contact.svg";
import card from "./icons/card.svg";
import contactus from "./icons/contactus.svg";
import developerIco from "./icons/developers.svg";
import documentScanner from "./icons/document-scanner.svg";
import downArrow from "./icons/down-arrow.svg";
import downCount from "./icons/down-count.svg";
import dropdownIcon from "./icons/DropdownIcon.svg";
import editDownArrow from "./icons/edit-down-arrow.svg";
import editPurpleIcon from "./icons/edit-purple.svg";
import email from "./icons/email.svg";
import encrypted from "./icons/encrypted.svg";
import folderManaged from "./icons/folder-managed.svg";
import mobile from "./icons/mobile.svg";
import phone from "./icons/phone.svg";
import print from "./icons/print.svg";
import projectSite from "./icons/projectSite.png";
import UploadDoc from "./icons/UploadDoc.svg";
import Upload_Icon from "./icons/UploadIcon.svg";
import website from "./icons/website.svg";
import whatsapp from "./icons/whatsapp.svg";
// import editIcon from "./icons/edit.svg";
import callfooter from "./icons/callfooter.svg";
import contactIcon from "./icons/contact-min.svg";
import Daresalam from "./icons/Dar e salam.jpg";
import dashboardIcon from "./icons/dashboard_icon.svg";
import deleteIcon from "./icons/DeleteIcon.svg";
import deleteRoundedIcon from "./icons/DeleteRoundedIcon.svg";
import developer from "./icons/developer.svg";
import developerIcon from "./icons/developer_icon.svg";
import documentStorage from "./icons/documentStorage.svg";
import dropDownArrow from "./icons/DropdownArrow.svg";
import editIcon from "./icons/EditIcon.svg";
import profile_icon from "./icons/Ellipse 440.svg";
import employer from "./icons/employer.svg";
import expand from "./icons/expand.svg";
import eyeClose from "./icons/eye-off.svg";
import eyeOpenWhite from "./icons/eye-open-white.svg";
import eyeOpen from "./icons/eye-open.svg";
import fileIcon from "./icons/fileIco.svg";
import filter from "./icons/filter.svg";
import footer from "./icons/Footer.png";
import games from "./icons/game_icon.png";
import greenTick from "./icons/green-tick.svg";
import greentickHome from "./icons/greentick.svg";
import home1 from "./icons/home1.png";
import home2 from "./icons/home2.png";
import iconDevelopers from "./icons/iconDevelopers.svg";
import iconDocuments from "./icons/iconDocuments.svg";
import iconExperience from "./icons/iconExperience.svg";
import iconUnits from "./icons/iconUnits.svg";
import infoIcon from "./icons/info.svg";
import institutesDark from "./icons/institutes-dark.svg";
import institutesLight from "./icons/institutes-light.svg";
import Kohetoor from "./icons/Koh e toor.jpg";
import league from "./icons/league_icon.png";
import leftArrow from "./icons/left-arrow.svg";
import leftblackarrow from "./icons/leftblackarrow.svg";
import leftwhitearrow from "./icons/leftwhitearrow.svg";
import locationContact from "./icons/location-contact.svg";
import locationfooter from "./icons/locationfooter.svg";
import loginImage from "./icons/login-image.jpg";
import mailContact from "./icons/mail-contact.svg";
import emailIcon from "./icons/mail-min.svg";
import masterIcon from "./icons/master_icon.svg";
import matches from "./icons/matches_icon.png";
import contactpage from "./icons/material-symbols_contact-page-rounded.svg";
import memberHome from "./icons/memberHome.svg";
import membersIco from "./icons/members.svg";
import memberIcon from "./icons/member_icon.svg";
import messagefooter from "./icons/messagefooter.svg";
import notification from "./icons/notification1.png";
import master from "./icons/ooui_special-pages-ltr.svg";
import paperGenerationDark from "./icons/paper-generation-dark.svg";
import paperGenerationLight from "./icons/paper-generation-light.svg";
import paperIcon from "./icons/paper.svg";
import pdfIcon from "./icons/pdf_icon.svg";
import skill from "./icons/ph_question-fill.svg";
import players from "./icons/players_icon.png";
import plusXLIcon from "./icons/plus-xl.svg";
import plusIcon from "./icons/plus.svg";
import plus2Icon from "./icons/plus2.svg";
import post from "./icons/post.svg";
import profile from "./icons/profile.svg";
import profileIcon from "./icons/profileIcon.svg";
import projectHome from "./icons/projectHome.svg";
import projectImage from "./icons/projectsite.svg";
import projectSiteIcon from "./icons/projectSiteIcon.svg";
import reporting from "./icons/reporting.svg";
import reports from "./icons/reports.svg";
import rightRoundIcon from "./icons/right-arrow-round.svg";
import rightIcon from "./icons/right-arrow.svg";
import searchPurple from "./icons/search-purple.svg";
import search from "./icons/search.svg";
import series from "./icons/series_icon.png";
import SeventhHeaven from "./icons/Seventh heaven.jpg";
import shreerang from "./icons/shreerang.png";
import shyamBusinessHub from "./icons/shyam business hub.jpg";
import ShyamGrace from "./icons/Shyam grace.jpg";
import ShyamParijat2 from "./icons/Shyam parijat 2.jpg";
import subscriptionIcon from "./icons/subscription_icon.svg";
import subTag from "./icons/SubTag.svg";
import systemIcon from "./icons/system_icon.svg";
import teacherDark from "./icons/teachers-dark.svg";
import teacherLight from "./icons/teachers-light.svg";
import teams from "./icons/team_icon.png";
import templates from "./icons/templates.svg";
import unit from "./icons/unit.svg";
import upCount from "./icons/up-count.svg";
import uploadIcon from "./icons/upload.svg";
import users from "./icons/User_icon.svg";
import vLine from "./icons/vLine.svg";
import warningIcon from "./icons/warning.svg";
import whiteTick from "./icons/white-tick.svg";
// import gvsLogo from "./logos/gvsLogo.svg";
import coinTableIcon from "./icons/coinTable.png";
import gvsLogoImg from "./logos/gvlLogo.png";
import hero from "./logos/hero.png";
import logoNavbar from "./logos/logoNavbar.png";
import mLogo from "./logos/my-property.png";
import mLogoType2 from "./logos/my-property2.svg";
import myPropertyLogo from "./logos/mypropertlogo.svg";
import settingOutline from "./logos/settings-outline.svg";

const allImgPaths = (() => ({
  matches,
  league,
  series,
  home1,
  iconDocuments,
  iconDevelopers,
  iconUnits,
  iconExperience,
  ShyamGrace,
  SeventhHeaven,
  shyamBusinessHub,
  shreerang,
  ShyamParijat2,
  callfooter,
  locationfooter,
  messagefooter,
  footer,
  Kohetoor,
  Daresalam,
  home2,
  unit,
  hero,
  reporting,
  developer,
  documentStorage,
  memberHome,
  projectHome,
  logoNavbar,
  advertise,
  profile,
  dashboard,
  games,
  players,
  teams,
  users,
  dashboardLight,
  dashboardDark,
  templates,
  reports,
  institutesLight,
  institutesDark,
  teacherDark,
  teacherLight,
  paperGenerationLight,
  mailContact,
  locationContact,
  paperGenerationDark,
  rightIcon,
  rightRoundIcon,
  loginImage,
  downArrow,
  projectSite,
  phone,
  website,
  mobile,
  encrypted,
  card,
  contactus,
  whatsapp,
  folderManaged,
  print,
  documentScanner,
  email,
  UploadDoc,
  Upload_Icon,
  actionRight,
  actionEdit,
  actionRelock,
  actionTrash,
  plusIcon,
  plus2Icon,
  plusXLIcon,
  alignLeftIcon,
  alignRightIcon,
  alignJustifyIcon,
  editIcon,
  editPurpleIcon,
  deleteIcon,
  pdfIcon,
  fileIcon,
  infoIcon,
  blacKTick,
  greentickHome,
  greenTick,
  cross,
  camera,
  upCount,
  downCount,
  filter,
  search,
  searchPurple,
  backArrow,
  eyeOpen,
  eyeClose,
  vLine,
  expand,
  leftArrow,
  leftwhitearrow,
  leftblackarrow,
  pageNotFound,
  warningIcon,
  paperIcon,
  backIcon,
  uploadIcon,
  addLabelQuestion,
  closeGray,
  whiteTick,
  notification,
  post,
  employer,
  applicant,
  skill,
  employ,
  bell,
  profile_icon,
  mLogo,
  mLogoType2,
  subtag,
  contactpage,
  master,
  editDownArrow,
  eyeOpenWhite,
  subTag,
  defaultProfile,
  developerIco,
  membersIco,
  callContact,
  dropdownIcon,
  addIcon,
  dashboardDevIco,
  dashboardMembersIco,
  dashboardSubMembersIco,
  dashboardProjIco,
  deleteRoundedIcon,
  dropDownArrow,
  projectImage,
  profileIcon,
  emailIcon,
  contactIcon,
  dashboardIcon,
  developerIcon,
  memberIcon,
  subscriptionIcon,
  masterIcon,
  systemIcon,
  myPropertyLogo,
  projectSiteIcon,
  // gvsLogo,
  gvsLogoImg,
  coinTableIcon,
  settingOutline,
}))();
export default allImgPaths;
